import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { HttpServiceBase } from '../classes/HttpServiceBase';

export interface AdminFilePayload {
    title: string;
    descr?: string;
    categoryId?: string;
    realFilename?: string;
    contentType?: string;
    fileBase64?: string;
}

/** Admin files CRUD (backend rest/fyes/admin/files); binaries live on S3. */
@Injectable({ providedIn: 'root' })
export class AdminFilesService extends HttpServiceBase {
    protected override baseUrl = '/admin/files';

    constructor(private http: HttpClient) {
        super();
        this.assign(this);
    }

    public list(): Observable<any> {
        return this._http.get(this.baseUrl)
            .pipe(map((r: any) => r), catchError(this.handleError.bind(this)));
    }

    public create(file: AdminFilePayload): Observable<any> {
        return this._http.post(this.baseUrl, file)
            .pipe(map((r: any) => r), catchError(this.handleError.bind(this)));
    }

    public update(id: string, file: AdminFilePayload): Observable<any> {
        return this._http.put(`${this.baseUrl}/${id}`, file)
            .pipe(map((r: any) => r), catchError(this.handleError.bind(this)));
    }

    /**
     * Short-lived presigned URL for the stored object.
     *
     * `inline` asks for a URL the browser will render (no Content-Disposition);
     * otherwise the URL forces a download under the original filename.
     */
    public getDownloadUrl(id: string, inline = false): Observable<any> {
        return this._http.get(`${this.baseUrl}/${id}/download`, { params: { inline } })
            .pipe(map((r: any) => r), catchError(this.handleError.bind(this)));
    }

    public delete(id: string): Observable<any> {
        return this._http.delete(`${this.baseUrl}/${id}`)
            .pipe(map((r: any) => r), catchError(this.handleError.bind(this)));
    }
}
